import c from "./lib/createApi";

/**
 * property
 */

const defaultUrl = "/v1/property";

export default {
  getDictionaryPropertyList: c("GET", defaultUrl + "/get-dictionary-property", true), // [property - 1] 사전 속성 조회
  getProcessPropertyList: c("GET", defaultUrl + "/get-process-property", true), // [property - 2]  공정도 속성 조회
  updateDictionaryProperty: c("POST", defaultUrl + "/update-dictionary-property", true), // [property - 3] 사전속성 저장 및 변경
  updateProcessProperty: c("POST", defaultUrl + "/update-process-property", true), // [property - 4] 공정도속성 저장 및 변경
  getReleaseProcessPropertyList: c("GET", defaultUrl + "/get-release-process-property", true), // [property - 5] 공개된 공정도 특정노드 속성 조회
  getAllReleaseProcessPropertyList: c("GET", defaultUrl + "/get-all-release-process-property", true), // [property - 6] 공개된 공정도 모든 속성 조회
  getAllProcessPropertyList: c("GET", defaultUrl + "/get-all-process-property", true), // [property - 7] 공정도 전체속성 조회
  getDeleteValidationProperty: c("GET", defaultUrl + "/get-delete-validation-property", true), // [property - 8] 사전속성 삭제검증
  updateRelatedProperty: c("POST", defaultUrl + "/update-related-property", true), // [property - 9] 사전속성, 참조 공정도 속성 일괄수정
  getPropertyClassList: c("GET", defaultUrl + "/propertyclass-list", true), // [property - 10] propertyclass 항목 불러오기
  getPropertyVocabularyList: c("GET", defaultUrl + "/propertyvocabulary-list", true), // [property - 11] propertyVocabulary 항목 불러오기
  createPropertyVocabulary: c("POST", defaultUrl + "/create-property-vocabulary", true), // [property - 12] propertyVocabulary 항목 신규 생성
  updatePropertyUnit: c("PUT",`${defaultUrl}/property/unit`,true), // [property - 13] 특정 속성(Property)의 단위(Unit) 값을 수정. 수정 시 기존 공개된 공정도가 있다면 즉시 재공개
};
